var Config = {
    wsUrl: "/api/ecolabel",
    businessLineId: "d3b7a627bfdb48b2b90f6201229c6af5",
    businessLine: "Personal Care",
    init() {
        var sws = document.getElementById("ecolabel-wsurl");
        if (sws) this.wsUrl = sws.value;
        var blid = document.getElementById("business-line-id");
        if (blid) this.businessLineId = blid.value;
        var bl = document.getElementById("business-line");
        if (bl) this.businessLine = bl.value;
        console.log(`The tool displays data for ${this.businessLine}`);
    }
};

export default Config;